const initialState = {
	location: null,
	previousLocation: null,
	searchTerm: '',
	selectedTag: '',
	startTimestamp: Math.round(+new Date() / 1000),
	endTimestamp: null,
	isFocusOnSearch: false,
};

export default function (state = initialState, action) {
	switch (action.type) {
		case '@@router/LOCATION_CHANGE':
			return {
				...state,
				previousLocation: state.location,
				location: {...action.payload.location},
			};
		case 'SET_SEARCH':
			return {
				...state,
				searchTerm:
					action.searchTerm !== undefined
						? action.searchTerm
						: state.searchTerm,
				isFocusOnSearch: action.isFocusOnSearch,
			};
		case 'RESET_APP_STATE':
			return {...initialState};
		case 'SET_SELECTED_TAG':
			return {...state, selectedTag: action.selectedTag};
		case 'SET_START_TIMESTAMP':
			return {...state, startTimestamp: action.startTimestamp};
		case 'SET_END_TIMESTAMP':
			return {...state, endTimestamp: action.endTimestamp};
		default:
			return state;
	}
}
